import { Close } from "@mui/icons-material";
import { IconButton, debounce } from "@mui/material";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import React, { useCallback, useState } from "react";
import SearchIcon from "../../../assets/images/icons/SearchIcon";
import styles from "./DebouncedInput.module.scss";

export type DebouncedInputProps = {
	searchValue?: string;
	debounceDuration?: number;
	searchIcon?: boolean;
	height?: string;
	placeHolder?: string;
} & TextFieldProps;

const DebouncedInput = ({
	searchValue = "",
	debounceDuration = 700,
	searchIcon = false,
	height = "40px",
	onChange,
	placeHolder,
	InputProps,
	...rest
}: DebouncedInputProps) => {
	const [localValue, setLocalValue] = useState(searchValue || "");
	const eraseSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		e.preventDefault();
		setLocalValue("");
		onChange?.({ target: { value: "" } } as React.ChangeEvent<HTMLInputElement>);
	};

	const handleDebouncedChange = useCallback(
		debounce((e) => onChange?.(e), debounceDuration),
		[],
	);
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setLocalValue(e.target.value);
		handleDebouncedChange(e);
	};

	return (
		<TextField
			placeholder={placeHolder ? placeHolder : ""}
			onChange={handleChange}
			InputProps={{
				style: {
					height,
					paddingLeft: "8px",
					fontSize: "14px",
				},
				startAdornment: searchIcon && <SearchIcon className={styles.searchIconStyle} />,
				endAdornment: localValue && (
					<IconButton disableRipple size="small" onClick={eraseSearch}>
						<Close sx={{ fontSize: "16px" }} />
					</IconButton>
				),
				...InputProps,
			}}
			{...rest}
			value={localValue}
		/>
	);
};

export default DebouncedInput;
